import { h } from "preact";
import { useState } from 'react';
import {Upload, Button, message} from 'antd';
import { UploadOutlined } from '@ant-design/icons';

export const FileUpload = ({ onChange, onRemove, personId, maxCount = 10}) => {
    const [fileList, setFileList] = useState([]);

    const handleChange = (info) => {
        const validFiles = info.fileList.filter(file => {
            const type = file.type || (file.originFileObj && file.originFileObj.type);
            return type === 'application/pdf' ||
                type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        });

        setFileList(validFiles);

        // Handle the completed upload
        if (info.file.status === 'done') {
            const file = info.file.originFileObj;
            const uid = info.file.uid;
            if (file) {
                onChange(file, uid);
            }
        }
        if (info.file.status === 'removed') {
            onRemove && onRemove(info.file.uid);
        }

    };

    const isUploadDisabled = personId?.length<6 || fileList.length >= maxCount;

    const beforeUpload = (file) => {
        const isPDForDoc = file.type === 'application/pdf' ||
            file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        if (!isPDForDoc) {
            message.error('You can only upload PDF or DOC files!');
            return false;
        }
        return true;
    };

    const uploadProps = {
        beforeUpload,
        fileList,
        onChange: handleChange,
        maxCount: maxCount,
        accept: '.pdf, .docx',
        onRemove: (file) => {
            // This will trigger the onChange event with file.status = 'removed'
            return true;
        }
    };

    const getDisabledMessage = () => {
        if (!personId || personId?.length<5) return "Please specify Person ID first";
        if (fileList.length >= maxCount) return `Maximum ${maxCount} files allowed`;
        return "";
    };


    return (
        <Upload {...uploadProps} disabled={isUploadDisabled}>
            <Button
                disabled={isUploadDisabled}
                title={getDisabledMessage()}
                icon={<UploadOutlined />}>Upload Document</Button>
        </Upload>
    );
};